// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const statuses = {
  1: 'TempOrder',
  2: 'Shipment in Process',
  3: 'Shipment Received',
  4: 'Shipment Processed',
  6: 'Awaiting Delivery',
  7: 'Payment Scheduled',
  8: 'Shipment not Received, Expires in 7 days',
  9: 'Problem',
  10: 'Returned',
  11: 'Awaiting shipment. Item offers may have changed',
  12: 'Rejected',
  13: 'Payment in Progress',
  14: 'Payment Unsuccessful',
  15: 'Paid',
  17: 'Handed into Evri',
  18: 'Shipment Delayed',
};

const paymentTypes = {
  1: 'Cheque',
  2: 'Bank transfer',
  3: 'PayPal',
  4: 'Voucher',
  5: 'Charity',
};

const rejectionReasons = {
  10: 'Pages marked/highlighted',
  11: 'Mouldy/unclean',
  12: 'Missing pages',
  14: 'Promo copy',
  15: 'Damaged',
  16: 'Below standard condition',
  17: 'Item not found',
  // CD, DVD
  1: 'Missing disc',
  2: 'Missing artwork',
  3: 'Counterfeit',
  4: 'Damaged disc',
  5: 'Heavy scratch',
  6: 'Incorrect disc',
  7: 'Incorrect case',
  8: 'Incorrect artwork',
  9: 'Copyright/DRM protected item',
  13: 'Missing insert and/or CD/DVD',
  18: 'Item not found',
  // GAMES
  19: 'Missing Game',
  20: 'Missing artwork',
  21: 'Counterfeit',
  22: 'Damaged disc',
  23: 'Heavy scratch',
  24: 'Incorrect disc',
  25: 'Incorrect case',
  26: 'Incorrect artwork',
  27: 'Copyright/DRM protected item',
  28: 'Missing insert and/or CD/DVD',
  29: 'Item not found',
};

const carrierId = {
  'Collect+': 1,
  Evri: 2,
};

const optionsTitle = [{
  value: 1,
  name: 'Mr.',
}, {
  value: 2,
  name: 'Ms.',
}, {
  value: 3,
  name: 'Mrs.',
}, {
  value: 4,
  name: 'Miss',
}];

const itemTypes = [
  {
    key: 1,
    value: 'Book',
  }, {
    key: 2,
    value: 'Games',
  }, {
    key: 3,
    value: 'CD/DVD',
  }, {
    key: 4,
    value: 'Mobile & Tablets',
  }
];

const discountTypes = {
  1: '%',
  2: '£',
};

export {
  statuses,
  paymentTypes,
  optionsTitle,
  rejectionReasons,
  carrierId,
  itemTypes,
  discountTypes,
};
